import {
  Button,
  Flex,
  Grid,
  SelectField,
  TextField,
} from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";

const UNITS = ["", "Litro", "Mililitro", "Kilogramo", "Gramo", "Otro"];
const INGREDIENTS = [
  "",
  "Glifosato",
  "Clorpirifós",
  "Abamectina",
  "Imidacloprid",
  "Mancozeb",
  "Oxicloruro de Cobre",
  "Azufre",
  "Propiconazol",
  "Tebuconazol",
  "Bacillus thuringiensis",
  "Trichoderma harzianum",
  "Extracto de Neem",
  "Aminoácidos",
  "Nitrato de Calcio",
  "Sulfato de Potasio",
];
const CLASSIFICATIONS = [
  "",
  "Fertilizante",
  "Insumo",
  "Fungicida",
  "Acaricida",
  "Insecticida",
  "Insumo para trampa",
  "Insumo para germinación",
  "Herbicida",
  "Bioinsumo",
  "Otro",
];
const PHYSICAL_TYPES = ["", "Sólido", "Líquido"];
const TOX_CATS = ["", "Bajo", "Moderado", "Alto", "Muy Alto"];

const InputForm = ({ onSubmit, type = "create", initialValues = {} }) => {
  const defaultState = {
    name: "",
    activeIngredient: "",
    unit: "",
    classification: "",
    physicalType: "",
    icaRegistration: "",
    toxicologicalCategory: "",
  };

  const [inputForm, setInputForm] = useState({ ...defaultState, ...initialValues });

  useEffect(() => {
    setInputForm({ ...defaultState, ...initialValues });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmitForm = () => {
    onSubmit && onSubmit(inputForm);
  };

  const onReset = () => setInputForm({ ...defaultState, ...initialValues });

  return (
    <>
      <Grid rowGap="15px" columnGap="15px" padding="20px">
        <Grid gap="15px" templateColumns={{ base: "1fr", large: "2fr 2fr" }}>
          <TextField
            name="name"
            label={strings.fields.name.label}
            value={inputForm.name || ""}
            onChange={handleChange}
          />
          <TextField
            name="icaRegistration"
            label={strings.fields.icaRegistration.label}
            value={inputForm.icaRegistration || ""}
            onChange={handleChange}
          />
        </Grid>

        <Grid gap="15px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
          <SelectField
            name="activeIngredient"
            label={strings.fields.activeIngredient.label}
            value={inputForm.activeIngredient || ""}
            onChange={handleChange}
          >
            {INGREDIENTS.map((opt) => (
              <option key={opt} value={opt}>
                {opt || "--"}
              </option>
            ))}
          </SelectField>

          <SelectField
            name="unit"
            label={strings.fields.unit.label}
            value={inputForm.unit || ""}
            onChange={handleChange}
          >
            {UNITS.map((opt) => (
              <option key={opt} value={opt}>
                {opt || "--"}
              </option>
            ))}
          </SelectField>
        </Grid>

        <Grid gap="15px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
          <SelectField
            name="classification"
            label={strings.fields.classification.label}
            value={inputForm.classification || ""}
            onChange={handleChange}
          >
            {CLASSIFICATIONS.map((opt) => (
              <option key={opt} value={opt}>
                {opt || "--"}
              </option>
            ))}
          </SelectField>

          <SelectField
            name="physicalType"
            label={strings.fields.physicalType.label}
            value={inputForm.physicalType || ""}
            onChange={handleChange}
          >
            {PHYSICAL_TYPES.map((opt) => (
              <option key={opt} value={opt}>
                {opt || "--"}
              </option>
            ))}
          </SelectField>
        </Grid>

        <SelectField
          name="toxicologicalCategory"
          label={strings.fields.toxicologicalCategory.label}
          value={inputForm.toxicologicalCategory || ""}
          onChange={handleChange}
        >
          {TOX_CATS.map((opt) => (
            <option key={opt} value={opt}>
              {opt || "--"}
            </option>
          ))}
        </SelectField>

        <Flex justifyContent="end">
          <Button children={strings.fields.buttons.reset} onClick={onReset} />
          <Button
            children={
              type === "create"
                ? strings.fields.buttons.create
                : strings.fields.buttons.save
            }
            onClick={onSubmitForm}
            variation="primary"
          />
        </Flex>
      </Grid>
    </>
  );
};

const strings = new LocalizedStrings({
  es: {
    fields: {
      name: {
        label: "Nombre",
      },
      activeIngredient: {
        label: "Ingrediente activo",
      },
      unit: {
        label: "Unidad",
      },
      classification: {
        label: "Clasificación",
      },
      physicalType: {
        label: "Tipo",
      },
      icaRegistration: {
        label: "Registro ICA",
      },
      toxicologicalCategory: {
        label: "Categoría Toxicológica",
      },
      buttons: {
        create: "Crear",
        save: "Guardar",
        reset: "Restablecer",
      },
    },
    validations: {
      incorrectValue: "Valor incorrecto",
    },
    responses: {
      errorSave: "Error al guardar el insumo",
    },
  },
});

export default InputForm;
